import React from 'react';
import styles from './index.module.css';

const CircularProgress = ({
  value = 0,
  size = 120,
  strokeWidth = 10,
  label,
  sublabel,
  showPercent = true,
  ariaLabel,
}) => {
  const clamped = Math.min(Math.max(value || 0, 0), 100);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference * (1 - clamped / 100);
  const center = size / 2;

  return (
    <div
      className={styles.root}
      style={{ width: size, height: size }}
      role='progressbar'
      aria-valuenow={Math.round(clamped)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel || `${Math.round(clamped)}% complete`}
    >
      <svg className={styles.svg} width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden='true'>
        <circle className={styles.track} cx={center} cy={center} r={radius} strokeWidth={strokeWidth} fill='none' />
        <circle
          className={styles.fill}
          cx={center}
          cy={center}
          r={radius}
          strokeWidth={strokeWidth}
          fill='none'
          strokeDasharray={circumference}
          strokeDashoffset={dashOffset}
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>
      <div className={styles.center}>
        {showPercent && (
          <span className={styles.value}>
            {Math.round(clamped)}
            <span className={styles.unit}>%</span>
          </span>
        )}
        {label && <span className={styles.label}>{label}</span>}
        {sublabel && <span className={styles.sublabel}>{sublabel}</span>}
      </div>
    </div>
  );
};

export default CircularProgress;
